import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import NavigationActions from "redux/navigation/actions";
import { compose } from "redux";
import { Button, Modal } from "reactstrap";
// import Select from "react-select";
import Loader from "components/Loader";
import ConformationModalUser from "components/common/ConformationModalUser";
import moment from "moment";
import { generateCsvFile } from "services/ReportServices";
import DatePicker from "react-datepicker";
import ReportEnhancer from "./Enhancer/ReportEnhancer";
const { success, error, fetching } = NavigationActions;

function Report(props) {
  let [loading, setLoading] = useState(false);
  const { values, setFieldValue, token } = props;
  let generateCsv = async () => {
    setLoading(true);
    let data = {
      startDate: values?.startDate,
      endDate: values?.endDate
    };
    await generateCsvFile(token, data).then(response => {
      if (response.success) {
        console.log(response);
        success(response.message);
        window.location.href = `${process.env.REACT_APP_BACKEND_URI}/${response.data}`;
        setLoading(false);
      } else {
        error(response.message);
      }
    });
    setLoading(false);
  };
  return (
    <div className="work-card ">
      <div className="row mb-3">
        <div className="col-sm headline ml-2">Reports</div>
      </div>
      <div className="work-body mt-4 card-box p-4">
        <div className="row">
          <div className="col-6">
            <div className="form-group">
              <label className="d-block">Start Date</label>
              <DatePicker
                className="form-control w-100 react-form-input p-4 "
                id="startDate"
                selected={values.startDate}
                value={values?.startDate}
                placeholder="Starting Date"
                dateFormat={"dd/MM/yyyy"}
                onChange={date => {
                  console.log("date", date);
                  setFieldValue("startDate", date);
                }}
                maxDate={Date.now()}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="form-group">
              <label className="d-block">End Date</label>
              <DatePicker
                className="form-control w-100 react-form-input p-4"
                id="endDate"
                dateFormat={"dd/MM/yyyy"}
                selected={values.endDate}
                minDate={values.startDate}
                value={values?.endDate}
                placeholder="Ending Date"
                onChange={date => {
                  console.log("date", date);
                  setFieldValue("endDate", date);
                }}
                maxDate={Date.now()}
              />
            </div>
          </div>
        </div>
        <div className="mt-2">
          <div className="d-flex flex-col  justify-content-center align-items-center">
            <Button
              className="btn btn-info  btn-bordered ml-3 export-button "
              onClick={() => generateCsv()}
            >
              Export
            </Button>
          </div>
        </div>

        {loading ? <Loader /> : null}
      </div>
    </div>
  );
}

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    token: state.auth.accessToken,
    user: state.auth.user,
    channel: state.navigation.channel
  };
};

export default compose(
  withRouter,
  ReportEnhancer,
  connect(mapStateToProps, {
    success,
    error,
    fetching
  })
)(Report);
